export default "/_next/static/images/border.87b9fcbcb997c3213459bb24c78ec823.png";